import { Select } from '@/components/ui/Select'
import { ThemeMode, useThemeStore } from '@/store/theme'
import { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

interface ThemeFormData {
  theme: ThemeMode
}

const themeOptions = [
  { value: 'auto', text: 'Auto (System)' },
  { value: 'light', text: 'Light' },
  { value: 'dark', text: 'Dark' },
]

export const ThemeSelect = () => {
  const mode = useThemeStore((state) => state.mode)
  const setMode = useThemeStore((state) => state.setMode)

  const methods = useForm<ThemeFormData>({
    defaultValues: { theme: mode },
  })

  const handleChange = useCallback(
    (value: string | string[]) => {
      setMode(value as ThemeMode)
    },
    [setMode]
  )

  return (
    <FormProvider {...methods}>
      <Select<ThemeFormData>
        name="theme"
        label="Theme"
        options={themeOptions}
        modalTitle="Select Theme"
        onChange={handleChange}
        testId="theme-select"
      />
    </FormProvider>
  )
}
